import { defineComponent as _defineComponent } from 'vue'
import { Country } from '@/enums/Country';
    import atFlag from '@/assets/img/flags/at.svg';
    import deFlag from '@/assets/img/flags/de.svg';
    import { storeToRefs } from 'pinia';
    import { useTHGGlobalStore } from '@/storenew/thg/global';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySwitcher',
  props: {
    showCurrentCountry: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
        showCurrentCountry: boolean;
    };

    const globalStore = useTHGGlobalStore();
    const { currentCountry } = storeToRefs(globalStore);

    

    function getCountryFlag(c: Country) {
        if (c === Country.AT) {
            return atFlag;
        }

        return deFlag;
    }

    function changeCountry(country: Country) {
        currentCountry.value = country;
        window.location.reload();
    }

return { __sfc: true,globalStore, currentCountry, props, getCountryFlag, changeCountry, Country }
}

})